import { useState } from "react";
import { Phone, Route } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { useLang } from "@/i18n";

export const FareCalculator = () => {
  const { t } = useLang();
  const f = t.fare;
  const [originIdx, setOriginIdx] = useState(0);
  const [destIdx, setDestIdx] = useState(5);
  const dest = f.destinations[destIdx];

  return (
    <section id="tariffe" className="border-y border-white/10 bg-[#0B0B10] py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow={f.eyebrow} title={f.title} accent={f.accent} />
        <Reveal>
          <div
            data-testid="fare-calculator-card"
            className="grid gap-10 rounded-3xl border border-white/10 bg-[#101017] p-8 sm:p-12 lg:grid-cols-[1fr_auto]"
          >
            <div className="grid gap-6 sm:grid-cols-2">
              <label className="block">
                <span className="mb-2 block font-mono-alt text-[11px] uppercase tracking-[0.25em] text-slate-500">
                  {f.originLabel}
                </span>
                <select
                  data-testid="fare-origin-select"
                  value={originIdx}
                  onChange={(e) => setOriginIdx(Number(e.target.value))}
                  className="w-full rounded-xl border border-white/15 bg-[#070709] px-4 py-3.5 text-sm text-white outline-none transition-colors focus:border-amber-400"
                >
                  {f.origins.map((o, i) => (
                    <option key={o} value={i}>{o}</option>
                  ))}
                </select>
              </label>
              <label className="block">
                <span className="mb-2 block font-mono-alt text-[11px] uppercase tracking-[0.25em] text-slate-500">
                  {f.destLabel}
                </span>
                <select
                  data-testid="fare-destination-select"
                  value={destIdx}
                  onChange={(e) => setDestIdx(Number(e.target.value))}
                  className="w-full rounded-xl border border-white/15 bg-[#070709] px-4 py-3.5 text-sm text-white outline-none transition-colors focus:border-amber-400"
                >
                  {f.destinations.map((d, i) => (
                    <option key={d.name} value={i}>{d.name}</option>
                  ))}
                </select>
              </label>
              <div className="flex items-center gap-3 text-sm text-slate-400 sm:col-span-2">
                <Route className="h-4 w-4 text-amber-400" />
                <span>
                  {f.origins[originIdx]} → {dest.name} • {f.duration} {dest.time}
                </span>
              </div>
            </div>
            <div className="flex flex-col items-start justify-center rounded-2xl border border-amber-400/25 bg-amber-400/5 p-8 lg:min-w-[300px]">
              <span className="font-mono-alt text-[11px] uppercase tracking-[0.25em] text-slate-500">
                {f.estimate}
              </span>
              <span
                data-testid="fare-estimate-output"
                className="mt-2 font-display text-4xl font-black text-amber-400"
              >
                {dest.price}
              </span>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <a
                  href="tel:+41766344242"
                  data-testid="fare-call-cta"
                  className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-6 py-3 font-display text-sm font-extrabold uppercase text-black transition-all duration-300 hover:bg-amber-300"
                >
                  <Phone className="h-4 w-4" />
                  {f.callCta}
                </a>
                <a
                  href="#prenota"
                  data-testid="fare-booking-link"
                  className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 font-display text-sm font-bold text-white transition-all duration-300 hover:border-amber-400/60 hover:text-amber-300"
                >
                  {f.bookCta}
                </a>
              </div>
              <span className="mt-3 text-xs text-slate-500">{f.note}</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
